/* sk-consent-bridge.js - carry the shopper's actual choice into Google Consent Mode.
 *
 * WHY THIS EXISTS. sk-analytics.js sets consent DEFAULTS and scopes them by region: denied
 * across the EEA and UK, granted elsewhere. Defaults are only half of Consent Mode. Shopify's
 * cookie banner is the consent UI on this store, and nothing was carrying its result back to
 * gtag, so the defaults were the only thing that ever applied. Two consequences, verified on
 * the storefront 2026-09-18: an EU shopper who pressed Accept stayed denied and went
 * unmeasured, and - the one that matters - a shopper who pressed Decline stayed granted, so
 * analytics storage continued after an explicit refusal. Shopify recorded the refusal
 * correctly (currentVisitorConsent().analytics === 'no'); nobody told Google.
 *
 * The banner is region-scoped by Shopify to the EU and UK (Settings > Customer privacy), and
 * the Data sharing opt out page covers California and 13 other states. Both of those depend on
 * a decline actually reaching the tag.
 *
 * This file only ever narrows or widens what sk-analytics.js already declared. It invents no
 * events and sends no data of its own.
 */
(function () {
  if (!window.SK_GA4_ID) return;
  /* Cookiebot is the consent surface now and signals Consent Mode itself. It also syncs its
   * answer into Shopify's customer-privacy API, which fires visitorConsentCollected with
   * analyticsAllowed/marketingAllowed keys this file does not read, so an opt-in was being
   * overwritten with "denied" after Cookiebot granted it. Stand down whenever Cookiebot's
   * script tag is on the page; this file only applies if the store goes back to Shopify's banner. */
  if (document.getElementById('Cookiebot')) return;

  function gtag() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(arguments);
  }

  var yes = function (v) {
    return v === true || v === 'yes';
  };

  function apply(c) {
    if (!c) return;
    gtag('consent', 'update', {
      analytics_storage: yes(c.analytics) ? 'granted' : 'denied',
      ad_storage: yes(c.marketing) ? 'granted' : 'denied',
      ad_user_data: yes(c.marketing) ? 'granted' : 'denied',
      ad_personalization: yes(c.marketing) ? 'granted' : 'denied'
    });
  }

  /* Fired by Shopify the moment the shopper answers the banner. */
  document.addEventListener('visitorConsentCollected', function (e) {
    apply(e && e.detail);
  });

  /* A returning shopper already answered on an earlier visit; Shopify has the answer stored
   * but fires no event for it, so read it once the API is up. An untouched banner reports
   * empty strings, which is not a decision - leave the regional defaults alone in that case. */
  function readStored() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || !cp.currentVisitorConsent) return;
      var c = cp.currentVisitorConsent();
      if (c && (c.analytics !== '' || c.marketing !== '')) apply(c);
    } catch (e) {}
  }

  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      if (!err) readStored();
    });
  } else {
    readStored();
  }
})();